import React from 'react';
import PropTypes from 'prop-types';
import { MDText } from 'i18n-react';
import { useLocale } from '@adsk/bim360-matrix-react-helpers/es/locale';
import objectValues from '@adsk/bim360-matrix-react-helpers/es/objectValues';
import { ENVS, REGIONS } from '@adsk/bim360-matrix-react-helpers/es/consts';
import EntityBlock from '../../EntityBlock';
import getPropsFromEntity from './getPropsFromEntity';

/**
 * A component rendering Meeting Item entity block.
 * @param entity
 * @param env
 * @param region
 * @param projectId
 * @param rest
 * @returns {*}
 * @constructor
 */
const MeetingItemEntityBlock = ({ entity, env, region, projectId, ...rest }) => {
  const { T } = useLocale(({ locale }) => new MDText(require(`./i18n/${locale}.json`)));
  const other = { ...rest, onRemoveClick: null };
  return <EntityBlock {...getPropsFromEntity({ entity, env, region, projectId, T })} {...other} />;
};

MeetingItemEntityBlock.propTypes = {
  /**
   * The Meeting Item entity we need to render.
   */
  entity: PropTypes.object.isRequired,
  /**
   * The environment. One of `ENVS` values.
   */
  env: PropTypes.oneOf(objectValues(ENVS)).isRequired,
  /**
   * The region. One of `REGIONS` values.
   */
  region: PropTypes.oneOf(objectValues(REGIONS)).isRequired,
  /**
   * The project ID
   */
  projectId: PropTypes.string.isRequired
};

export default MeetingItemEntityBlock;
